import React, { Component } from 'react';
import { toast } from 'react-toastify';
import {
  ProgressIndicatorSkeleton,
  ProgressIndicator,
  ProgressStep,
  Modal,
  Loading,
  Checkbox,
} from 'carbon-components-react';
import Numeral from 'numeral';
import queryString from 'qs';
import NumberFormat from 'react-number-format';

import { Breadcrumb } from '../../../../../components';
import {
  getByDmService,
  pathDmService,
  deleteDmService,
  insertDmService,
} from '../../../../../services/Api';
import { getStatusUniformIndex } from '../../../../../utils/modifiers';
import 'numeral/locales/pt-br';

import {
  PENDENTE,
  PREPARACAO,
  PRONTAENTREGA,
  ENTREGUE,
  CANCELADO,
} from '../../../../../config/StatusRequest';
import appConfig from '../../../../../config/app-config';

const arrStatus = [PENDENTE.id, PREPARACAO.id, PRONTAENTREGA.id, ENTREGUE.id, CANCELADO.id];
class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: true,
      isUpdating: false,
      openMdStatus: false,
      cancelModal: false,
      openMdQtd: false,
      statusIndex: 0,
      currentStep: 0,
      statusRequest: null,
      newStatusRequest: null,
      checkQuantidade: false,
      checkValor: false,
      budget: 0,
      produtosEstoque: 0,
    };
  }

  componentDidMount() {
    this.getItems();
    Numeral.locale('pt-br');
  }

  getItems = async () => {
    const { match, location } = this.props;
    let data = null;

    const query = queryString.parse(location.search.slice(1));

    const { msg } = query;
    if (msg) toast.success(msg);

    try {
      data = await getByDmService('/Pedido/GetBrindesDetalheAtendente', match.params.id);
      if(data){
        const orderStatus = data && data.status;
        const statusIndex = getStatusUniformIndex(orderStatus ? orderStatus.id : {});
        const currentStep = arrStatus.indexOf(data.itemPedido.status.id) + 1;
        const quantidadeCarrinho = data.itemPedido.quantidadeEntregue || data.itemPedido.quantidade;
        const novaQuantidadeCarrinho = quantidadeCarrinho;
        const quantidadeOriginal = data.itemPedido.quantidade;
        const quantidadePedidoOriginal = data.itemPedido.quantidade;
        const { estoque } = data.itemPedido;
        const estoqueOriginal = estoque + quantidadeCarrinho;
        const imagem = data.itemPedido.fotoDestaque ? data.itemPedido.fotoDestaque.caminho : '';
        const status = data.itemPedido.status.id;
        const statusRequest = data.itemPedido.status.nome;
        let newStatus = null;
        // const preco = data.itemPedido.valor / quantidadeCarrinho;
        const subTotal = data.itemPedido.valor;
    
        if (status === PENDENTE.id) {
          newStatus = PREPARACAO;
        } else if (status === PREPARACAO.id) {
          newStatus = PRONTAENTREGA;
        } else if (status === PRONTAENTREGA.id) {
          newStatus = ENTREGUE;
        } else if (status === ENTREGUE.id) {
          newStatus = CANCELADO;
        }
    
        this.setState({
          data,
          isLoading: false,
          newStatusRequest: newStatus,
          quantidadeOriginal,
          subTotal,
          statusRequest,
          estoqueOriginal,
          statusIndex,
          currentStep,
          quantidadeCarrinho,
          novaQuantidadeCarrinho,
          quantidadePedidoOriginal,
          estoque,
          imagem,
        });
      }

    } catch (e) {
      toast.error('Ocorreu um erro ao carregar a campanha');
      this.setState({ data: null, isLoading: false });
    }
  };

  onQtdDevolucaoChange = event => {
    const val = event.target.value;
    this.setState({ produtosEstoque: val });
  };

  onQtdDevolucaoCalcChange = event => {
    const val = event.target.value;
    const {subTotal} = this.state;

    const devolucao = val * subTotal;
    this.setState({ calQtdDevolucao: val, budget: devolucao });
  };

  onQtdChange = (/* event */) => {
    this.toggleQtdModal();
    // const val = event.target.value;
    // const estoqueNovo = this.state.estoqueOriginal - val;
    // let qtd = val;

    // let _estoque = estoqueNovo;
    // console.log(val, qtd, estoqueNovo);

    // if (!(val >= 0 && estoqueNovo >= 0)) {
    //   if (val >= 0) {
    //     qtd = this.state.estoqueOriginal;
    //     _estoque = 0;
    //   } else {
    //     qtd = 0;
    //     _estoque = this.state.estoqueOriginal;
    //   }
    // }
    // const subTotal = this.state.preco * qtd;

    // this.setState({ quantidadeCarrinho: qtd, estoque: _estoque, subTotal });
  };

  addToCart = () => {
    this.toggleQtdModal();
  }

  toggleUpdateModal = () => {
    this.setState(prevState => ({ openMdStatus: !prevState.openMdStatus }));
  };

  toogleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  toggleQtdModal = () => {
    this.setState(prevState => ({ openMdQtd: !prevState.openMdQtd }));
  };

  cancelRequest = async () => {
    const { match, history } = this.props;
    const { data } = this.state;
    const { id } = match.params;
    const idPedido = data.pedido.id;
    try {
      await deleteDmService('/Pedido/DeleteItemPedido', id);
      this.toggleModal();
      history.push(`/admin/trade/brinde/${idPedido}/todos`);
      toast.success('Item removido com sucesso');
    } catch (e) {
      toast.error('Não foi possível remover o item');
    }
  };

  toggleModal = () => {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
      selectedId: null,
    }));
  };

  updateOrderStatus = async () => {
    const { data } = this.state;
    const { match } = this.props;
    const { id } = match.params;

    const index = arrStatus.indexOf(data.itemPedido.status.id) + 1;
    const serviceUrl = `/Pedido/AtualizaStatusItemPedido/${id}?status=${arrStatus[index]}&retirouUniforme=&dataRetiradaUniforme=`;
    this.updateStatus(serviceUrl, index);
  };

  updateOrderQtd = async () => {
    const { data, checkQuantidade, checkValor, produtosEstoque, budget, novaQuantidadeCarrinho } = this.state;
    const { match } = this.props;
    const { id } = match.params;

    const obj = {
      Pedido: data.pedido.id,
      ItemPedido: id,
      checkQuantidade,
      checkValor,
      produtosEstoque,
      budget,
      quantidadeEntregue:novaQuantidadeCarrinho,
      Acao: 1,
    };
    try {
      const {history} = this.props;
      await insertDmService('/Pedido/AjustePedidoBrinde', obj);
      this.toggleQtdModal();
      toast.success("Item atualizado com sucesso");
      history.goBack();
      //window.location.href = `${window.location.pathname}?msg=Item atualizado com sucesso`;
    } catch (ex) {
      if (ex.message) {
        toast.error(ex.message);
      } else {
        toast.error('Não foi possível atualizar o item');
      }
    }
  };

  updateStatus = async (serviceUrl, indexMsg) => {
    const messages = [
      'Status alterado para Pendente',
      'Status alterado para Preparação',
      'Status alterado para Pronto para Entrega',
      'Status alterado para Entregue',
      'Status alterado para Cancelado',
      'Pedido Cancelado conforme o solicitado.',
    ];

    this.setState({ statusIndex: indexMsg });
    pathDmService(serviceUrl, {})
      .then(() => {
        toast.success(messages[indexMsg]);

        if (indexMsg <= 4) {
          this.toggleUpdateModal();
          window.location.href = window.location.href;
        } else {
          this.toogleCancelModal();
        }
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar modificar o status');
        this.toggleUpdateModal();
      });
  };

  changeTab = ({ index }) => {
    const { match, history } = this.props;
    const route = index === 0 ? 'detalhe' : 'informacoes';
    history.push(`${match.url}/${route}`);
  };

  setImagem = img => {
    this.setState({ imagem: img });
  };

  changeQtd = (e) => {
    const {subTotal, quantidadeCarrinho} = this.state;
    if(!e.target.value)
      return;

    let qtd = e.target.value ? Number(e.target.value) : 0;
    if(qtd > quantidadeCarrinho)
      qtd = quantidadeCarrinho;
    else if(qtd < 0) {
      qtd = 0;
    }

    const devolucao = quantidadeCarrinho - qtd;
    this.setState({
      novaQuantidadeCarrinho: qtd,
      produtosEstoque: devolucao,
      calQtdDevolucao: devolucao,
      budget: devolucao * subTotal
    });
  }

  buttonRenderRight() {
    const { data, statusIndex, newStatusRequest } = this.state;
    return (
      <div>

        {statusIndex <= 3 &&
          data.itemPedido.status.id !== 5 && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              onClick={this.toggleUpdateModal}
              type="submit"
            >
              {newStatusRequest ? newStatusRequest.value : ''}
            </button>
          )}
        {data.itemPedido.status.id === 5 && <h3 className="text-warning">Item Cancelado</h3>}
      </div>
    );
  }

  renderThumbs() {
    const { data } = this.state;

    return (
      data.fotos &&
      data.fotos.map(img => (
        <div key={img.id} className="pointer bx--col-xs-3  bx--col-md-12">
          <img
            onClick={() => this.setImagem(img.caminho)}
            className="img-responsive img-galery"
            alt="thumbnail"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
            style={{ backgroundImage: `url('${appConfig.IMAGE_PATH + img.caminho}')` }}
          />
        </div>
      ))
    );
  }

  render() {
    const {
      data,
      isLoading,
      isUpdating,
      openMdStatus,
      cancelModal,
      openMdQtd,
      currentStep,
      statusRequest,
      newStatusRequest,
      quantidadeOriginal,
      produtosEstoque,
      estoque,
      imagem,
      novaQuantidadeCarrinho,
      calQtdDevolucao,
      quantidadeCarrinho,
      quantidadePedidoOriginal,
      budget,
      subTotal,
      checkQuantidade,
      checkValor,
    } = this.state;
    const { history } = this.props;

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />
          <section className="content-wrapper content-wrapper--large">
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    return (
      <div>
        {data ? (
          <div>
            <Breadcrumb
              title={`Pedido ${data.pedido.numero}`}
              description={`Solicitado em ${data.pedido.dataSolicitacao} por ${
                data.pedido.solicitante
              }`}
              renderRight={this.buttonRenderRight()}
              renderLeft={(() => (
                <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                  <svg width="16" height="14" viewBox="0 0 16 14">
                    <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                  </svg>
                </div>
              ))()}
            />
            <section className="content-wrapper content-wrapper--large brinde-detalhe">
              <div className="table-uniforms">
                <ProgressIndicator>
                  <ProgressStep
                    label="Pendente"
                    current={currentStep === 1}
                    complete={currentStep > 1}
                  />
                  <ProgressStep
                    label="Preparação"
                    current={currentStep === 2}
                    complete={currentStep > 2}
                  />
                  <ProgressStep
                    label="Pronto para entrega"
                    current={currentStep === 3}
                    complete={currentStep > 3}
                  />
                  <ProgressStep
                    label="Entregue"
                    current={currentStep === 4}
                    complete={currentStep > 4}
                  />
                  <ProgressStep label="Cancelado" current={currentStep === 5} />
                </ProgressIndicator>
                <div className="bx--row" style={{ marginTop: '50px' }}>
                  <div className="bx--col-xs-12  bx--col-md-1 bx--col-xl-2 bx--col-xxl-1">
                    <div className="bx--row">{this.renderThumbs()}</div>
                  </div>
                  <div className="bx--col-xs-12  bx--col-md-6  bx--col-xl-5 bx--col-xxl-5 mg-bt-24 ">
                    <img
                      className="img-responsive img-force"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                      alt="thumbnail"
                      style={{ backgroundImage: `url('${appConfig.IMAGE_PATH + imagem}')` }}
                    />
                  </div>
                  <div className="bx--col-xs-12 bx--col-md-5 text-right description-breadcrumb">
                    <p className="title-thumb">{data.itemPedido.nome}</p>
                    <p className="product-desc">{data.itemPedido.descricao}</p>
                    <p className="price-thumb">{Numeral(subTotal).format('$ 0.00')}</p>
                    <div className="quantity-thumb mg-top-30">
                      <strong>Quantidade solicitada:</strong>       
                      <br />
                      <input
                        className="number-input"
                        name="quantidadePedidoOriginal"
                        value={quantidadePedidoOriginal}
                        disabled
                      />
                      <br />
                      <br />
                      <strong>Quantidade entregue:</strong>
                      <input
                        type="number"
                        className="number-input"
                        name="quantidadeCarrinho"
                        id="tj-input"
                        step={1}
                        min={0}
                        max={quantidadeCarrinho}
                        value={novaQuantidadeCarrinho}
                        onChange={this.changeQtd}
                      />
                    </div>
                    <div className="clearfix" />
                    <div className="quantity-thumb mg-top-10 crear-fix">
                      <label>
                        {estoque}
                        {' '}
em estoque
                      </label>
                    </div>
                    <div className="clearfix" />
                    <button
                      className="bx--btn btn-secondary-color btn-lg opcity add-to-cart"
                      onClick={this.addToCart}
                      disabled={subTotal <= 0}
                      type="button"
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>

              <Modal
                open={openMdStatus}
                onRequestSubmit={this.updateOrderStatus}
                onRequestClose={this.toggleUpdateModal}
                modalHeading="Modificar Status"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                <div>
                  <p>
                    Você tem certeza que deseja alterar o status do pedido 
                    {' '}
                    <br />
                    <strong>{data.itemPedido.nome}</strong>
                    {' '}
de
                    <strong> 
                      {' '}
                      {statusRequest}
                      {' '}
                    </strong>
                    {' '}
para
                    {' '}
                    <strong>{newStatusRequest ? newStatusRequest.value : null}</strong>
?
                  </p>
                </div>
              </Modal>
              <Modal
                open={openMdQtd}
                onRequestSubmit={this.updateOrderQtd}
                onRequestClose={this.toggleQtdModal}
                modalHeading="Devolução de brinde e/ou Budget"
                primaryButtonText="Confirmar"
                secondaryButtonText="Cancelar"
              >
                <div className="warning-modal-txt">
                  <p>O que você deseja devolver?</p>
                  <div className="modal-inner-table" style={{maxWidth:"640px"}}>
                    <div className="bx--row">
                      <div className="bx--col-xs-5">
                        <Checkbox
                          id="checkQuantidade"
                          labelText="Produtos para o estoque"
                          onChange={(value) => {
                            this.setState({ checkQuantidade: value });
                          }}
                        />
                      </div>
                      <div className="bx--col-xs-5">
                        <input
                          type="number"
                          className="number-input"
                          name="produtosEstoque"
                          id="tj-input"
                          disabled={!checkQuantidade}
                          step={1}
                          min={0}
                          max={quantidadeOriginal}
                          value={produtosEstoque}
                          onChange={this.onQtdDevolucaoChange}
                        />
                      </div>
                      <div className="bx--col-xs-2">
                        <strong style={{fontSize:".7em"}}>
                        <br/>
                          (Máx: {quantidadeOriginal})
                        </strong>
                      </div>
                    </div>
                    <div className="bx--row" style={{marginTop:10}}>
                      <div className="bx--col-xs-5">
                        <Checkbox
                          id="checkValor"
                          labelText="Budget para solicitante"
                          onChange={value => {
                            this.setState({ checkValor: value });
                          }}
                        />
                      </div>
                      <div className="bx--col-xs-2">
                        <input
                          type="number"
                          className="number-input"
                          name="calQtdDevolucao"
                          style={{marginTop:2}}
                          id="tj-input"
                          disabled={!checkValor}
                          step={1}
                          min={0}
                          max={quantidadeCarrinho - novaQuantidadeCarrinho}
                          value={calQtdDevolucao}
                          onChange={this.onQtdDevolucaoCalcChange}
                        />
                      </div>
                      <div className="bx--col-xs-3">
                        <NumberFormat
                          getInputRef={ref => {
                            this.budgetRef = ref;
                          }}
                          id="budget"
                          disabled={!checkValor}
                          className="bx--text-input bx--text__input"
                          fixedDecimalScale
                          decimalSeparator=","
                          prefix="R$ "
                          thousandSeparator="."
                          placeholder="R$ 0,00"
                          value={budget}
                          allowNegative={false}
                          decimalScale={2}
                          readOnly
                          onValueChange={(values, e) => {
                            this.setState({
                              [e.target.id]: values.value ? Number(values.value) : null,
                              // isEdited: true,
                            });
                          }}
                          onFocus={() => {
                            if (!budget && this.budgetRef) {
                              this.budgetRef.value = '';
                            }
                          }}
                        />
                      </div>
                      <div className="bx--col-xs-2">
                        <strong style={{fontSize:".7em"}}>
                        <br/>
                          (Máx: {Numeral(quantidadeOriginal * subTotal).format('$ 0.00')})
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              <Modal
                open={cancelModal}
                onRequestSubmit={this.cancelRequest}
                onRequestClose={this.toogleCancelModal}
                modalHeading="Retirar produto do Pedido"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                <div className="warning-modal-txt">
                  <p>Você tem certeza que deseja retirar produto do pedido?</p>
                </div>
              </Modal>

              {isUpdating && <Loading small />}
            </section>
          </div>
        ):
        (
          <div className="bx--row">
            <div className="bx--col-md-12">
              <p>
                Nenhum Produto encontrado
              </p>
            </div>
          </div>

        )}
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Gifts/Edit/Main.js